export default __webpack_public_path__ + "svg/CompaniesLogos/logo_digital-tactics.svg?8b86d09c";